import React from 'react';
import { Link } from 'react-router-dom';
import CreditCardInput from 'react-credit-card-input';
import FormItem from '../../general/formitem.js';

export default class CourseInfo extends React.Component
{
    constructor(props)
    {
        super(props);
        this.buytypeChanged = this.buytypeChanged.bind(this);
        this.buyCourse = this.buyCourse.bind(this);
        this.state = {
            loaded: false,
            error: false,
            errorMessage: "",
            buytype: 0,
            orgUsers: [],
            courseUsers: [],
            courseInfo: {}
        }
    }
    componentDidMount()
    {
        this.loadCourseInfo(0);
    }
    loadCourseInfo()
    {
        this.setState({loaded: false});
        this.props.api.send({
            controller: "Course",
            action: "GetCourse",
            method: "post",
            body: JSON.stringify({courseID: this.props.courseID}),
            success: (result) =>
            {
                result.courseID === 0 ?
                    this.setState({loaded: true, error: true}) :
                    this.setState({loaded: true, error: false, courseInfo: result});
            },
            error: (err) =>
            {
                this.setState({loaded: true, error: true});
            }
        })
    }
    reset()
    {
        this.setState({
            loaded: false,
            error: false,
            errorMessage: "",
            buytype: 0,
            orgUsers: [],
            courseUsers: [],
            courseInfo: {}
        });
        this.loadCourseInfo();
    }
    buytypeChanged(event)
    {
        var data = this.state;
        data[event.target.name] = event.target.value;
        this.setState({data});
        if (this.state.orgUsers.length === 0)
        {
            this.setState({loaded: false})
            this.props.api.send({
                controller: "Organization",
                action: "GetUsers",
                method: "get",
                success: (result) => {
                    result.success ?
                        this.setState({loaded: true, orgUsers: result.users}) :
                        this.setState({loaded: true, error: true})
                },
                error: (err) => {
                    this.setState({loaded: true, error: true})
                }
            })
        }
    }
    selectAll(event)
    {
        var cu = this.state.courseUsers;
        for (var u=0; u < this.state.orgUsers.length; u++)
        {
            if (cu.indexOf(this.state.orgUsers[u].userID) === -1)
            {
                cu.push(this.state.orgUsers[u].userID);
            }
        }
        this.setState({courseUsers: cu});
    }
    deselectAll(event)
    {
        var cu = [];
        this.setState({courseUsers: cu});
    }
    checkUserChanged(event, uid)
    {
        var cu;
        if (event.target.checked)
        {
            if (this.state.courseUsers.indexOf(uid) === -1)
            {
                cu = this.state.courseUsers;
                cu.push(uid);
                this.setState({courseUsers: cu});
            }
        }
        else
        {
            var idx = this.state.courseUsers.indexOf(uid);
            if (idx !== -1)
            {
                cu = this.state.courseUsers;
                cu.splice(idx, 1);
                this.setState({courseUsers: cu});
            }
        }
    }
    buyCourse()
    {
        this.props.api.send({
            controller: "Course",
            action: "BuyCourse",
            method: "post",
            body: JSON.stringify({
                courseID: this.props.courseID, buyType: this.state.buytype,
                courseUsers: this.state.courseUsers
            }),
            success: (result) => {
                if (result.success)
                result.success ?
                    this.reset() :
                    this.setState({loaded: true, errorMessage: result.message});
            },
            error: (err) => {
                this.setState({loaded: true, errorMessage: "An error occurred while purchasing this course.  Please try again later."})
            }
        })
    }
    render()
    {
        const buytypes = [
            {name: "Myself", value: 0},
            {name: "All Users in my Organization", value: 1},
            {name: "Specific Users in my Organization", value: 2}
        ];
        const userList = this.state.orgUsers.map((u) =>
            <tr key={u.userID}>
                <td>{u.username}</td>
                <td>
                    {this.state.courseInfo.ownedByUsers.indexOf(u.userID) === -1 ? (
                        <input type="checkbox" checked={this.state.courseUsers.indexOf(u.userID) !== -1}
                            onChange={(e) => this.checkUserChanged(e, u.userID)} />
                    ) : null}
                </td>
            </tr>
        )
        const total = this.state.loaded ? 
            this.state.buytype === 1 ? 
                (
                    this.state.courseInfo.coursePrice * (this.state.orgUsers.length - this.state.courseInfo.ownedByUsers.length)
                ).toFixed(2) :
                this.state.buytype === 2 ?
                    (this.state.courseInfo.coursePrice * this.state.courseUsers.length).toFixed(2) :
                this.state.courseInfo.owned ? 0.00.toFixed(2) :
            this.state.courseInfo.coursePrice.toFixed(2)
        : 0.00.toFixed(2);
        return (
            <div className="lmsdisplayarea">
                {this.state.loaded ?
                    this.state.error ? (
                        <div>
                            <div className="lmserror">An error occurred while loading information about this course.</div>
                            <Link to="/Shop" className="bodylink">Click here</Link> to return to the course catalog.
                        </div>
                    ) : (
                        <div>
                            <h3>{this.state.courseInfo.courseName}</h3>
                            <div className="lmsvalidationerror">
                                {this.state.errorMessage}
                            </div>
                            <img src={"/courses/" + this.state.courseInfo.courseID + "/Thumb.jpg"} alt="" />
                            <p>
                                {this.state.courseInfo.courseDescription}
                            </p>
                            {this.state.courseInfo.owned && this.state.courseInfo.singleUser ? (
                                <div>
                                    You own this course.
                                    <div className="lmsdivmargin">
                                        <Link to={"/LaunchCourse/" + this.state.courseInfo.courseID} className="lmsbutton">Launch Course</Link>
                                    </div>
                                </div>
                            ) : (
                                <div>
                                    <div className="lmsdivmargin">
                                        <strong>Price</strong>: ${this.state.courseInfo.coursePrice.toFixed(2)}
                                    </div>
                                    {!this.props.cart.cartCourses.some((c) => c.courseID === this.state.courseInfo.courseID) ? (
                                        <input type="button" name="AddToCart" value="Add To Cart" className="lmsbutton" 
                                            onClick={(e) => this.props.addToCart(e, this.state.courseInfo.courseID)} />  
                                    ) : (
                                        <div>
                                            <i>This course is in your cart.</i><br />
                                            <input type="button" name="RemoveFromCart" value="Remove from Cart" className="lmsbutton" 
                                                onClick={(e) => this.props.removeFromCart(e, this.state.courseInfo.courseID)} />  
                                        </div>
                                    )}
                                    
                                    {true ? null : (
                                    <div>
                                        {this.state.courseInfo.singleUser ? null : (
                                            <div className="lmsdivmargin">
                                                <FormItem label="Buy For:" name="buytype" type="radiobuttons" options={buytypes} className="lmsformitemleft"
                                                    value={this.state.buytype} inputChanged={this.buytypeChanged} />
                                                { this.state.orgUsers.length > 0 && this.state.buytype === 2 ? (
                                                    <table className="lmstable lmsshortusertable">
                                                        <tbody>
                                                            <tr>
                                                                <th colSpan="2">
                                                                    <input type="button" className="lmsbutton" value="Select All" onClick={(e) => this.selectAll(e)} />
                                                                    <input type="button" className="lmsbutton" value="Deselect All" onClick={(e) => this.deselectAll(e)} />
                                                                </th>
                                                            </tr>
                                                            {userList}
                                                        </tbody>
                                                    </table>
                                                ) : null}
                                                <div className="lmsdivmargin">
                                                    <strong>Total:</strong> ${total}
                                                </div>
                                            </div>
                                        )}
                                        <div className="lmspayment">
                                            <CreditCardInput />
                                        </div>
                                        <input type="button" name="buy" value="Buy" className="lmsbutton" onClick={this.buyCourse} />
                                    </div>
                                    )}
                                </div>
                            )}
                        </div>
                    )
                : (
                    <div className="lmscenter"><img src="/images/spinner.svg" alt="Loading..." /></div>
                )}
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/course/catalog/courseinfo.js